import { ITypedAPITarget } from "network/NetworkStapler";
import { IGeorgeFitOnboarding, IGeorgeFitStatusResponse, IGeorgeFitFitnessResponse } from "types/georgeFit";
import { IAccount } from "types/account";

export function getStatus(): ITypedAPITarget<IGeorgeFitStatusResponse> {
    return {
        url: "proxy/ggw/fit/public/user/status",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        method: "GET",
        parse: json => json as IGeorgeFitStatusResponse
    };
}

export function getFitness(): ITypedAPITarget<IGeorgeFitFitnessResponse> {
    return {
        url: "proxy/ggw/fit/public/user/fitness",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        method: "GET",
        parse: json => json as IGeorgeFitFitnessResponse
    };
}

export function getAccounts(): ITypedAPITarget<IAccount[]> {
    return {
        url: "/proxy/g/api/my/accounts",
        headers: {
            "Accept": "application/json",
        },
        parse: (json: any) => {
            return json.collection as IAccount[];
        }
    };
}


// WEBPACK FOOTER //
// ./src/network/GeorgeFitAPI.ts